import {
    UPDATE_NVQUAL_CURRENT_STATUS,
    UPDATE_NVQUAL_CURRENT_COMMENT,
    UPDATE_NVQUAL_CURRENT_EDIT,
    UPDATE_NVQUAL_CURRENT_REVISION_NAME
  } from './constants'

  const updateStatus = (statusNum) => ({type: UPDATE_NVQUAL_CURRENT_STATUS, statusNum})
  const updateComment = (text) => ({type: UPDATE_NVQUAL_CURRENT_COMMENT, text})
  const updateEdit = (curRev) => ({type: UPDATE_NVQUAL_CURRENT_EDIT, curRev})
  const updateRevisionName = (text) => ({type: UPDATE_NVQUAL_CURRENT_REVISION_NAME, text})
  export {
    updateStatus,
    updateComment,
    updateEdit,
    updateRevisionName
  }
  
